'use es6';

import { isEqual, findIndex } from 'underscore';
import { getFormFieldGroups } from 'FormsUI/selectors/FormDefinition';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import { updateFormFieldDefinition } from './FormDefinition';
import { removeFormField } from './FormDragDrop';
import { getFormFieldsByPropertyId } from 'FormsUI/selectors/FormDefinition';
import { getObjectTypeIdValue } from 'FormsCommonComponents/form-definition/utils/FormFieldUtils';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import removeItemFromArray from 'forms-utils-lib/utils/array/removeItemFromArray';
import updateItemInArray from 'forms-utils-lib/utils/array/updateItemInArray';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { CREATE_DEPENDENT_FIELD_RULE, DELETE_DEPENDENT_FIELD_RULE } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import Log from 'forms-utils-lib/logger/Logger';
function removeFormFieldByName(name, objectTypeId) {
  return (dispatch, getState) => {
    const formFieldGroups = getFormFieldGroups(getState());
    let formFieldGroupIndex = -1;
    let formFieldIndex = -1;
    while (isEqual(formFieldIndex, -1) && formFieldGroupIndex < formFieldGroups.length) {
      try {
        formFieldGroupIndex = formFieldGroupIndex + 1;
        formFieldIndex = findIndex(formFieldGroups[formFieldGroupIndex].fields, {
          name,
          objectTypeId
        });
      } catch (error) {
        Log.error('Thrown error while matching field to group for deletion', {
          formFieldGroups,
          error
        });
      }
    }
    if (formFieldIndex > -1) {
      dispatch(removeFormField(formFieldGroupIndex, name, objectTypeId));
    }
  };
}
export function addDependentField(formField, newDependentFieldFilter) {
  return (dispatch, getState) => {
    trackEditorInteraction(CREATE_DEPENDENT_FIELD_RULE);
    const existingFormFieldsByPropertyId = getFormFieldsByPropertyId(getState());
    const objectTypeIdForDependentField = getObjectTypeIdValue(newDependentFieldFilter.dependentFormField.objectTypeId, newDependentFieldFilter.dependentFormField.propertyObjectType);
    const objectTypeIdFormField = getObjectTypeIdValue(formField.objectTypeId, formField.propertyObjectType);
    const formFieldObjectTypeId = getPropertyObjectTypeId(newDependentFieldFilter.dependentFormField);
    const formFieldId = formFieldObjectTypeId;
    const newDependentFieldFilters = formField[FormFieldKeys.DEPENDENT_FIELD_FILTERS].concat([newDependentFieldFilter]);
    dispatch(updateFormFieldDefinition(formField.name, objectTypeIdFormField, FormFieldKeys.DEPENDENT_FIELD_FILTERS, newDependentFieldFilters));
    if (Object.prototype.hasOwnProperty.call(existingFormFieldsByPropertyId, formFieldId)) {
      dispatch(removeFormFieldByName(formFieldId, objectTypeIdForDependentField));
    }
  };
}
export function editDependentField(formField, dependentFieldFilterIndex, newDependentFieldFilter) {
  return dispatch => {
    const newDependentFieldFilters = updateItemInArray(formField[FormFieldKeys.DEPENDENT_FIELD_FILTERS], dependentFieldFilterIndex, newDependentFieldFilter);
    dispatch(updateFormFieldDefinition(formField.name, getObjectTypeIdValue(formField.objectTypeId, formField.propertyObjectType), FormFieldKeys.DEPENDENT_FIELD_FILTERS, newDependentFieldFilters));
  };
}
export function removeDependentField(formField, dependentFieldFilterIndex) {
  return dispatch => {
    trackEditorInteraction(DELETE_DEPENDENT_FIELD_RULE);
    const newDependentFieldFilters = removeItemFromArray(formField[FormFieldKeys.DEPENDENT_FIELD_FILTERS], dependentFieldFilterIndex);
    dispatch(updateFormFieldDefinition(formField.name, getObjectTypeIdValue(formField.objectTypeId, formField.propertyObjectType), FormFieldKeys.DEPENDENT_FIELD_FILTERS, newDependentFieldFilters));
  };
}